/* eslint-disable capitalized-comments */
import { strapiInstance } from '@/constants/axios.instances.constants';
import type { UseApiCall } from '@/hooks/useStrapiApi';
import { buildStrapiUrl, loadAbort } from '@/utils';
import type { PaginaData } from '@/interfaces/strapi';
import { pageMapper } from '@/mappers';
import type { PaginaDataModel, StrapiResponseModel } from '@/interfaces/model';

export type PaginaCollectionRes = StrapiResponseModel<PaginaDataModel>;
type PaginaFlatModel = PaginaDataModel & { id: number | string };

function unwrapFirst<T = any>(raw: any): T | null {
	const d = raw?.data;
	const item = Array.isArray(d) ? d[0] : d;
	if (!item) return null;
	const attrs = item.attributes ?? item;
	return { id: item.id ?? attrs.id, ...attrs } satisfies T;
}

export const getPage = (slug: string): UseApiCall<PaginaData | null> => {
	const controller = loadAbort();

	const url = buildStrapiUrl({
		base: '/paginas',
		fields: ['title', 'slug', 'body'],
		filters: { slug: { $eq: slug }, active: true },
	});

	console.log('[getPage] URL =', url);

	return {
		call: strapiInstance.get(url, {
			signal: controller.signal,
			transformResponse: [
				(raw: string) => {
					const json = JSON.parse(raw) as PaginaCollectionRes;
					const first = unwrapFirst<PaginaFlatModel>(json);
					return first ? pageMapper(first) : null;
				},
			],
		}),
		controller,
	};
};
